"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Correspondence = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var App_1 = require("../../App");
var Message_1 = require("./Message");
var getLastTimeInMessageGroup_1 = require("./helpers/getLastTimeInMessageGroup");
var styles = __importStar(require("./Correspondence.module.css"));
var getMessages = function (api, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getChatMessages(data).catch(function (err) { return console.error(err); })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, __spreadArray([], response.items, true).reverse()];
        }
    });
}); };
var Correspondence = function (_a) {
    var setReplayMessage = _a.setReplayMessage;
    var intl = (0, react_intl_1.useIntl)();
    var _b = (0, react_1.useContext)(App_1.WidgetContext), socketService = _b.socketService, api = _b.api, widgetSettings = _b.widgetSettings;
    var _c = (0, react_1.useState)([]), messages = _c[0], setMessages = _c[1];
    /** Используется чтобы после подгрузки изображений в сообщениях вызывать scrollToBottom(), т.к. картинки могут подгрузиться позже */
    var _d = (0, react_1.useState)(0), loadedImages = _d[0], setLoadedImages = _d[1];
    var messagesEndRef = (0, react_1.useRef)(null);
    var scrollToBottom = function () {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    (0, react_1.useEffect)(function () {
        if (!socketService || !api)
            return;
        var eventListener = {
            'new message': function (message) {
                setMessages(function (msgs) { return __spreadArray(__spreadArray([], msgs, true), [message], false); });
                scrollToBottom();
            },
            'message deleted': function (data) {
                var deletedMessage = messages.find(function (message) { return String(message.id) === String(data.id); });
                if (deletedMessage) {
                    deletedMessage.deleted_at = new Date().toISOString();
                    deletedMessage.text = intl.formatMessage({ id: 'messageDeleted' });
                    setMessages(__spreadArray([], messages, true));
                }
            },
        };
        socketService.addEventListener(eventListener);
        return function () { return socketService.removeEventListener(eventListener); };
    }, [socketService, api, messages, intl]);
    (0, react_1.useEffect)(function () {
        if ((socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) && api) {
            var _a = socketService.joinResponseData, chat_key = _a.chat_key, client_id = _a.client_id, user_id = _a.user_id;
            getMessages(api, { channel: 'widget', chat_key: chat_key, client_id: client_id, user_id: user_id }).then(function (messages) { return setMessages(messages); });
        }
    }, [api, socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData]);
    (0, react_1.useEffect)(function () {
        scrollToBottom();
    }, [messages, loadedImages]);
    var onDeleteMessage = function (messageId) { return socketService === null || socketService === void 0 ? void 0 : socketService.deleteMessageEmit(messageId); };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles.correspondenceContainer }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [messages
                    .filter(function (message) { return !message.deleted_at; })
                    .map(function (message, index, messagesArr) {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(Message_1.Message, { message: message, index: index, messagesArr: messagesArr, backgroundColor: widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor, clientId: (_a = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _a === void 0 ? void 0 : _a.client_id, lastTimeInMessageGroup: (0, getLastTimeInMessageGroup_1.getLastTimeInMessageGroup)(index, messagesArr), onDeleteMessage: onDeleteMessage, onReplayMessage: setReplayMessage, setLoadedImages: setLoadedImages }, message.id));
                }), (0, jsx_runtime_1.jsx)("div", { ref: messagesEndRef })] }) })));
};
exports.Correspondence = Correspondence;
